










































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  ScheduleCalendarHeaderDate,
  ScheduleCalendarMode,
  Schedule,
  TutorSchedule,
  TutorSelector,
  ScheduleRequest,
  ScheduleMoveMode
} from '@/modules/schedule';
import { Subject } from '@/models/subject';
import ScheduleEditModal from '@/components/schedule/scheduleEditModal.vue';
import { Person } from '@/models/person';
import draggable from 'vuedraggable';

@Component({
  components: {
    ScheduleEditModal,
    draggable,
  },

  filters: {
    memo(value: string) {
      if (value.length > 20) {
        const tmp = value.substring(0, 20);
        return tmp + '...';
      }
      return value;
    }
  }
})
export default class extends Vue {
  private ScheduleCalendarMode = ScheduleCalendarMode;

  private readonly COL_CNT = 8;
  private readonly WEEKDAYS = [ '日', '月', '火', '水', '木', '金', '土' ];
  private isOpenEditModal = false;
  private modalFormData: ScheduleRequest = {
    calendarId: 0,
    scheduleId: 0,
    tutorId: '',
    weekday: 0,
    date: null,
    stringStart: '',
    stringEnd: '',
    subjectIds: [],
    capacity: 0,
    memo: '',
    copyReservers: false,
  };
  private tutors: TutorSelector[] = [];
  private reservers: Person[] = [];
  private enableTableView = true;
  private targetYearMonth: Date | null = null;

  // HACK: 本来の型は ScheduleCalendarMode。enum を指定するとそれは number だってエラー出るので number 定義しておきます。
  @Prop({required: true})
  private mode: number;

  @Prop({required: true})
  private headers: ScheduleCalendarHeaderDate[];

  @Prop({required: true})
  private schedules: TutorSchedule[];

  private scheduleMoveMode: ScheduleMoveMode = ScheduleMoveMode.None;

  public closeEditModal() {
    this.isOpenEditModal = false;
  }

  @Watch('headers')
  private onChangedHeaders() {
    // ヘッダ以外の更新を行うのに必要な記述。
    // ElementUI の Table Method doLayout では更新されなかったので。。
    this.enableTableView = false;
    this.$nextTick(() => {
      this.enableTableView = true;
    });
  }

  private enableView(schedule: Schedule, header: ScheduleCalendarHeaderDate) {
    // 日付の指定がある場合は日付判定
    if (header.date !== null) {
      if (schedule.unixtimeDate) {
        return header.date.getDate() === (new Date(schedule.unixtimeDate * 1000)).getDate();
      }
      return false;
    }

    // 曜日判定
    return schedule.weekday === header.weekday;
  }

  private getHeaderLabel(header: ScheduleCalendarHeaderDate) {
    if (!header.date) {
      return this.WEEKDAYS[header.weekday];
    }
    return `${header.date.getMonth() + 1}/${header.date.getDate()}(${this.WEEKDAYS[header.date.getDay()]})`;
  }

  private getDraggableClassName(row: TutorSchedule, header: ScheduleCalendarHeaderDate) {
    if (!header.date) {
      return `draggable_${row.tutorId}_week_${header.weekday}`;
    }
    return `draggable_${row.tutorId}_day_${header.date.getDate()}`;
  }

  private clickCell(weekSchedule: TutorSchedule, bar: any, element: HTMLElement) {
    // 全体予約カレンダーの方からアクセスされている場合は処理しない
    if (this.mode === ScheduleCalendarMode.Reservation) {
      return;
    }

    // どの要素を選択したか抽出する
    const parentElement = element.parentElement;
    let index = -1;
    if (parentElement) {
      for (let i = 1 ; i < parentElement.children.length ; ++i) {
        const child = parentElement.children[i];
        if (child.className === element.className) {
          index = i - 1;
          break;
        }
      }
    }

    if (index >= 0) {
      const header = this.headers[index];

      this.modalFormData = {
        calendarId: 0,
        scheduleId: 0,
        tutorId: weekSchedule.tutorId,
        weekday: header.weekday,
        date: header.date,
        stringStart: '',
        stringEnd: '',
        subjectIds: [],
        capacity: 1,
        memo: '',
        copyReservers: false,
      };

      this.targetYearMonth = header.date ? new Date(header.date.getFullYear(), header.date.getMonth()) : null;

      this.tutors = [];
      this.schedules.forEach((value: TutorSchedule) => {
        const schedule = this.schedules.find((value2: TutorSchedule) => {
          return value2.tutorId === value.tutorId;
        });
        if (schedule) {
          this.tutors.push({
            tutorId: value.tutorId,
            tutorName: value.tutorName,
            enableSubjects: JSON.parse(JSON.stringify(schedule.enableSubjects)),
          });
        }
      });
      this.reservers = [];

      this.scheduleMoveMode = ScheduleMoveMode.None;
      this.isOpenEditModal = true;

    }
  }

  private clickSchedule(weekSchedule: TutorSchedule, schedule: Schedule) {
    if (event) {
      event.stopPropagation();
    }

    this.scheduleMoveMode = ScheduleMoveMode.None;
    this.editSchedule(weekSchedule, schedule);
  }

  private editSchedule(weekSchedule: TutorSchedule, schedule: Schedule) {
    // modal 内で表示するデータの作成
    this.modalFormData = {
      calendarId: 0,
      scheduleId: schedule.scheduleId,
      tutorId: weekSchedule.tutorId,
      weekday: schedule.weekday,
      date: schedule.unixtimeDate ? new Date(schedule.unixtimeDate * 1000) : null,
      stringStart: schedule.stringStart,
      stringEnd: schedule.stringEnd,
      subjectIds: [],
      capacity: schedule.capacity,
      memo: schedule.memo,
      copyReservers: false,
    };

    this.targetYearMonth = this.modalFormData.date
      ? new Date(this.modalFormData.date.getFullYear(), this.modalFormData.date.getMonth())
      : null;

    schedule.subjects.forEach((subject: Subject) => {
      this.modalFormData.subjectIds.push(subject.id);
    });

    // スケジュールから講師一覧を作成
    this.tutors = [];
    this.schedules.forEach((value: TutorSchedule) => {
      const findSchedule = this.schedules.find((value2: TutorSchedule) => {
        return value2.tutorId === value.tutorId;
      });
      if (findSchedule) {
        this.tutors.push({
          tutorId: value.tutorId,
          tutorName: value.tutorName,
          enableSubjects: JSON.parse(JSON.stringify(findSchedule.enableSubjects)),
        });
      }
    });
    this.reservers = schedule.reservers !== undefined ?
      JSON.parse(JSON.stringify(schedule.reservers)) :
      [];

    this.isOpenEditModal = true;
  }

  private send(requestData: ScheduleRequest) {
    this.$emit('send', requestData);
  }

  private move(requestData: ScheduleRequest) {
    this.$emit('move', requestData);
  }

  private copy(requestData: ScheduleRequest) {
    this.$emit('copy', requestData);
  }

  private cancel() {
    switch (this.scheduleMoveMode) {
      case ScheduleMoveMode.Move:
      case ScheduleMoveMode.Copy:
        this.rollbackSchedule();
        break;
    }
  }

  private remove(scheduleId: number) {
    this.$emit('remove', scheduleId);
  }

  private remaining(capacity: number, reserverNumber: number) {
    const ret = capacity - reserverNumber;
    return ret >= 0 ? ret : 0;
  }

  private clickReserverName(studentId: string, scheduleId: number) {
    this.$emit('click-reserver-name', studentId, scheduleId);
  }

  private clickAddReserver(scheduleId: string) {
    this.$emit('click-add-reserver', scheduleId);
  }

  private async endMove(evt: any) {
    const scheduleId: number = Number(evt.item.dataset.scheduleid);
    const fromTutorId: string = evt.from.dataset.tutorid;
    const toTutorId: string = evt.to.dataset.tutorid;
    const fromWeek = Number(evt.from.dataset.week);
    const toWeek = Number(evt.to.dataset.week);
    const fromDay: number | null = evt.from.dataset.day ? Number(evt.from.dataset.day) : null;
    const toDay: number | null = evt.to.dataset.day ? Number(evt.to.dataset.day) : null;
    const ctrlKey: boolean = evt.originalEvent.ctrlKey;

    if (fromTutorId !== toTutorId) {
      // 禁止の為、戻す
      this.rollbackSchedule();
      return;
    }

    if (!ctrlKey && fromTutorId === toTutorId && fromWeek === toWeek && fromDay === toDay) {
      // 移動、かつ同じ枠内は何もしない
      return;
    }

    this.moveSchedule(ctrlKey, scheduleId, fromTutorId, toWeek, toDay);
  }

  private moveSchedule(
    isCopy: boolean,
    scheduleId: number,
    tutorId: string,
    toWeek: number,
    toDay: number | null): boolean {

      const tutorSchedule = this.schedules.find((item) => item.tutorId === tutorId);
      if (!tutorSchedule) {
        return false;
      }

      const fromScheduleIndex = tutorSchedule.schedules.findIndex((item) => item.scheduleId === scheduleId);
      if (fromScheduleIndex < 0) {
        return false;
      }

      const fromSchedule = tutorSchedule.schedules[fromScheduleIndex];
      const fromDate = toDay ? new Date(fromSchedule.unixtimeDate! * 1000) : null;
      const toDate = fromDate && toDay ? new Date(fromDate.getFullYear(), fromDate.getMonth(), toDay) : null;

      const toSchedule: Schedule = {
        scheduleId: fromSchedule.scheduleId,
        weekday: toWeek,
        unixtimeDate: toDate ? toDate.getTime() / 1000 : null,
        stringStart: fromSchedule.stringStart,
        stringEnd: fromSchedule.stringEnd,
        capacity: fromSchedule.capacity,
        memo: fromSchedule.memo,
        subjects: [...fromSchedule.subjects],
        reservers: [...fromSchedule.reservers],
      };

      this.scheduleMoveMode = isCopy ? ScheduleMoveMode.Copy : ScheduleMoveMode.Move;
      this.editSchedule(tutorSchedule, toSchedule);

      return true;
  }

  private rollbackSchedule() {
    const list = [...this.schedules];
    this.schedules.splice(0, this.schedules.length);
    this.$nextTick(() => {
      this.schedules.push(...list);
    });
  }
}
